import { APIClient } from "./apiCore";
import * as url from "./urls";
import { Utils } from "../helpers/utils";
import { MemberRole, WpEmpFilterType } from "../../src/redux/workplace/wpTypes"

const api = new APIClient();

export const loadPostTitleApi = (keyword: string, tagSet: string[], memberRole: MemberRole, tagIds: number[] | null, filterUnRead: boolean, filterNotClose: boolean, empFilterType: WpEmpFilterType/*includeFilterEmpRelated: boolean | null*/, includePostIds: string[] | null, tagCatMatchedAll?: string[] | null) => {
  return api.fnPostForm(url.WP_LOAD_POST_TITLE, { keyword, tagSet, memberRole, tagIds: tagIds, filterUnRead: filterUnRead, filterNotClose: filterNotClose, empFilterType/*includeFilterEmpRelated*/, includePostIds, tagCatMatchedAll });
}

export const loadPostConverApi = (postId: string) => {
  return api.fnPostForm(url.WP_LOAD_POST_CONVER, { postId });
}

export const loadPostInfoApi = (postId: string) => {
  return api.fnPostForm(url.WP_LOAD_POST_INFO, { postId });
}

export const updateReadApi = (postIdParent: string) => {
  return api.fnPostForm(url.WP_UPDATE_READ, { postIdParent });
}

export const getRoleUnreadCountApi = (sendNotification: boolean) => {
  return api.fnPost(url.WP_GET_ROLE_UNREAD_COUNT, { sendNotification });
}